import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from '../../apollo';
import {
  CreateLeadgenFormMutation,
  CreateLeadgenFormMutationVariables
} from '../leadgenForms/__generated__/CreateLeadgenFormMutation';
import { CREATE_LEADGEN_FORM_MUTATION } from './createLeadgenForm.mutation';

interface MutationProps {
  onStart?: () => void;
  onCompleted?: () => void;
  onError: (errors: string[]) => void;
}

export const useCreateLeadgenForm = ({ onStart, onCompleted, onError }: MutationProps) => {
  const [createLeadgenForm] = useMutation<CreateLeadgenFormMutation, CreateLeadgenFormMutationVariables>(
    CREATE_LEADGEN_FORM_MUTATION,
    {
      client: kmsClient,
      onCompleted: (data) => {
        if (data.createLeadgenForm?.errors?.length) {
          onError(data.createLeadgenForm.errors);
        } else if (onCompleted) {
          onCompleted();
        }
      },
      onError: (error) => onError([error.message])
    }
  );

  return (variables: CreateLeadgenFormMutationVariables) => {
    if (onStart) onStart();
    createLeadgenForm({ variables });
  };
};
